// Site root (route "/"), roadmap #108: a plain browser visit to the bare hostname
// used to fall through the catch-all straight into InvalidQr, which reads as a
// broken link. This is the intentional page for that visit — it explains how the
// site is normally reached and offers a discreet way into the staff surface.
// Any other unknown/invalid path (a real but unrecognised code) still falls to
// the catch-all InvalidQr screen, untouched.
import StaticPageLayout from './legal/StaticPageLayout'
import { t } from '../i18n'

const RootLanding = () => {
  return (
    <StaticPageLayout title={t.rootLandingTitle}>
      <p className="cf-subtitle">{t.rootLandingIntro}</p>
      <p className="cf-landing-footer">
        <a href="#/staff">{t.rootLandingStaffLink}</a>
      </p>
    </StaticPageLayout>
  )
}

export default RootLanding
